/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { OktaUserService } from 'src/app/shared/services/oktauser.service';
import { CybersocxdrService } from '../../../shared/services/xtendedsoc/cybersocxdr.service';
import { getDefaultHighchartOptions } from '../../utils';
import { ClientInfos } from '../../../shared/model/cybersocxdr/microsocClientInfo';
import { OcdContactDto } from 'src/app/shared/model/cybersocxdr/ocdContact';
import { ClientContact } from 'src/app/shared/model/cybersocxdr/clientContact';
import { ClientTechnologyDto } from 'src/app/shared/model/cybersocxdr/clientTechnology';
import { TranslateService } from '@ngx-translate/core';
import * as Highcharts from 'highcharts';

// eslint-disable @typescript-eslint/naming-convention
const technologiesMap = {
  'Rapid7 InsightIDR': { iconPath: '/assets/images/icons/rapid7.svg' },
  'Cortex XDR': { iconPath: '/assets/images/icons/palo.svg' },
  'Cortex XSOAR': { iconPath: '/assets/images/icons/palo.svg' },
  'Crowdstrike falcon': { iconPath: '/assets/images/icons/crowdstrike.svg' },
  'Tehtris XDR': { iconPath: '/assets/images/icons/tehtris.svg' },
  'Sentinel One': { iconPath: '/assets/images/icons/sentinelone.svg' },
  Sekoia: { iconPath: '/assets/images/icons/sekoia.svg' },
  Grafana: { iconPath: '/assets/images/icons/grafana.svg' },
  'Harfanglab EDR': { iconPath: '/assets/images/icons/harfanglab.svg' },
};

@Component({
  selector: 'app-xtended-contract-page',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.scss'],
})
export class XtendedSOCContractComponent implements OnInit {
  clientTechnologies: Array<ClientTechnologyDto> = [];

  // Dummy client information
  clientInfo: ClientInfos = {};
  ocdContacts: OcdContactDto[];
  clientContacts: ClientContact[];
  selectedTenant: string;

  constructor(
    private cybersocxdrService: CybersocxdrService,
    private oktaUserService: OktaUserService,
    private readonly translate: TranslateService
  ) {}

  ngOnInit() {
    const tens = JSON.parse(localStorage.getItem('okta-tenants'));
    if (tens && tens.selectedTenant) {
      this.selectedTenant = tens.selectedTenant;
    } else {
      this.oktaUserService.listGroups().then((groups) => {
        const userGroupsTok = groups.filter((g) => g.profile.name.startsWith('USERS_'));
        if (userGroupsTok.length === 1) {
          this.selectedTenant = userGroupsTok[0].split('_')[1];
        }
      });
    }

    Highcharts.setOptions(getDefaultHighchartOptions());

    this.init();
  }

  parseSLA(sla: string | number) {
    if (typeof sla == 'string') {
      const convertedMinutes = parseInt(sla, 10);
      if (Number.isNaN(convertedMinutes)) {
        return sla;
      }
      sla = convertedMinutes;
    }

    if (sla == 0) {
      // Best effort SLA
      return this.translate.instant('pages.cybersocxdr.dashboard.bestEffortSla');
    }

    if (sla < 60) {
      return `${sla} minutes`;
    }
    return `${Math.floor(sla / 60)}h` + (sla % 60 !== 0 ? `${sla % 60}min` : '');
  }

  async init() {
    this.clientInfo = await this.cybersocxdrService.getClientInfo();
    console.log(this.clientInfo);
    this.clientTechnologies = (await this.cybersocxdrService.getClientTechnologies()).map((technology) => ({
      ...technology,
      path: technologiesMap[technology.brand].iconPath,
    }));

    this.getOrganizationData();
  }

  /** Get the organization data and generate the organization options from it */
  async getOrganizationData() {
    this.clientContacts = await this.cybersocxdrService.getClientContacts();
    this.ocdContacts = await this.cybersocxdrService.getOcdContacts();
  }

  /** Send the new data, and opportunistically update on the frontend */
  sendNewClientContacts(newContacts: ClientContact[]) {
    this.cybersocxdrService.putClientContacts(newContacts);
    this.clientContacts = newContacts;
  }
}
